import { ArrowRight } from "lucide-react";
import { DEALERSHIP_URL } from "@/constants/site";
import { Reveal } from "@/lib/motion";
import { useTranslation } from "react-i18next";

export const DealershipCTA = ({ content = {} }) => {
  const { t } = useTranslation();
  return (
  <section id="bayilik" data-testid="dealership-cta-section" className="bg-cream py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <div className="relative overflow-hidden rounded-[2.5rem] border border-detail bg-surface px-6 py-16 sm:px-16 sm:py-20 text-center grain-overlay">
          <div className="relative">
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-brand">{content.eyebrow || "Bayilik"}</span>
            <h2 className="mt-4 mx-auto max-w-3xl font-heading font-bold text-ink text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight">{content.title || "Nolena Global Ailesine Katılın."}</h2>
            <p className="mt-6 mx-auto max-w-2xl text-base sm:text-lg text-ink/70 leading-relaxed">{content.description || "Güçlü markalarımız ve büyüyen ürün portföyümüzle bayilerimize sürdürülebilir iş ortaklığı sunuyoruz."}</p>
            <a href={DEALERSHIP_URL} data-testid="dealership-apply-btn" className="mt-10 inline-flex items-center justify-center gap-2 rounded-full bg-brand px-9 py-4 text-base font-semibold text-cream hover:bg-brand2 transition-colors duration-200">{t("common.applyNow")} <ArrowRight className="h-5 w-5" /></a>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
  );
};
